/*
 *  UTILS
 *  @author: jd@cals.arizona.edu
 */

/* tslint:disable no-var prefer-const no-bitwise one-variable-per-declaration prefer-for-of */
/* eslint-disable prefer-for-of triple-equals */

export{};
declare global {
    interface Array<T> {
        inArray(comparer: any): boolean;
        pushIfNotExist(element: T, comparer?: any): T[];
    }
}

 /**** BROWSER SHIMS *****/

if (!String.prototype.trim) {
  String.prototype.trim = function () {
    return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  };
}

if (!Date.now) {
  Date.now = function now() {
    return new Date().getTime();
  };
}


/**** POLYFILLS *****/

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
if (!Array.prototype.find) {
  Array.prototype.find = function(predicate) {
    if (this === null) {
      throw new TypeError('Array.prototype.find called on null or undefined');
    }
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function');
    }
    let list = Object(this);
    let length = list.length >>> 0;
    let thisArg = arguments[1];
    let value;

    for (let i = 0; i < length; i++) {
      value = list[i];
      if (predicate.call(thisArg, value, i, list)) {
        return value;
      }
    }
    return undefined;
  };
}


// Production steps of ECMA-262, Edition 5, 15.4.4.14
// Reference: http://es5.github.io/#x15.4.4.14
if (!Array.prototype.indexOf) {
  Array.prototype.indexOf = function(searchElement, fromIndex) {

    let k;

    // 1. Let o be the result of calling ToObject passing
    //    the this value as the argument.
    if (this == null) {
      throw new TypeError('"this" is null or not defined');
    }

    let o = Object(this);

    // 2. Let lenValue be the result of calling the Get
    //    internal method of o with the argument "length".
    // 3. Let len be ToUint32(lenValue).
    let len = o.length >>> 0;

    // 4. If len is 0, return -1.
    if (len === 0) {
      return -1;
    }

    // 5. If argument fromIndex was passed let n be
    //    ToInteger(fromIndex); else let n be 0.
    let n = +fromIndex || 0;

    if (Math.abs(n) === Infinity) {
      n = 0;
    }

    // 6. If n >= len, return -1.
    if (n >= len) {
      return -1;
    }

    // 7. If n >= 0, then Let k be n.
    // 8. Else, n<0, Let k be len - abs(n).
    //    If k is less than 0, then let k be 0.
    k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

    // 9. Repeat, while k < len
    while (k < len) {
      // a. Let Pk be ToString(k).
      //   This is implicit for LHS operands of the in operator
      // b. Let kPresent be the result of calling the
      //    HasProperty internal method of o with argument Pk.
      //   This step can be combined with c
      // c. If kPresent is true, then
      //    i.  Let elementK be the result of calling the Get
      //        internal method of o with the argument ToString(k).
      //   ii.  Let same be the result of applying the
      //        Strict Equality Comparison Algorithm to
      //        searchElement and elementK.
      //  iii.  If same is true, return k.
      if (k in o && o[k] === searchElement) {
        return k;
      }
      k++;
    }
    return -1;
  };
}


//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
if (!Array.prototype.forEach) {

  Array.prototype.forEach = function(callback, thisArg) {

    let T, k;

    if (this == null) {
      throw new TypeError(' this is null or not defined');
    }

    // 1. Let O be the result of calling toObject() passing the
    // |this| value as the argument.
    let O = Object(this);

    // 2. Let lenValue be the result of calling the Get() internal
    // method of O with the argument "length".
    // 3. Let len be toUint32(lenValue).
    let len = O.length >>> 0;

    // 4. If isCallable(callback) is false, throw a TypeError
    //exception. // See: http://es5.github.com/#x9.11
    if (typeof callback !== "function") {
      throw new TypeError(callback + ' is not a function');
    }

    // 5. If thisArg was supplied, let T be thisArg; else let
    // T be undefined.
    if (arguments.length > 1) {
      T = thisArg;
    }

    // 6. Let k be 0
    k = 0;

    // 7. Repeat, while k < len
    while (k < len) {

      let kValue;

      // a. Let Pk be ToString(k).
      //    This is implicit for LHS operands of the in operator
      // b. Let kPresent be the result of calling the HasProperty
      //    internal method of O with argument Pk.
      //    This step can be combined with c
      // c. If kPresent is true, then
      if (k in O) {

        // i. Let kValue be the result of calling the Get internal
        // method of O with argument Pk.
        kValue = O[k];

        // ii. Call the Call internal method of callback with T as
        // the this value and argument list containing kValue, k, and O.
        callback.call(T, kValue, k, O);
      }
      // d. Increase k by 1.
      k++;
    }
    // 8. return undefined
  };
}

//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter
if (!Array.prototype.filter) {
  Array.prototype.filter = function(fun/*, thisArg*/) {
    'use strict';

    if (this === void 0 || this === null) {
      throw new TypeError();
    }

    let t = Object(this);
    let len = t.length >>> 0;
    if (typeof fun !== 'function') {
      throw new TypeError();
    }

    let res = [];
    let thisArg = arguments.length >= 2 ? arguments[1] : void 0;
    for (let i = 0; i < len; i++) {
      if (i in t) {
        let val = t[i];

        // NOTE: Technically this should Object.defineProperty at
        //       the next index, as push can be affected by
        //       properties on Object.prototype and Array.prototype.
        //       But that method's new, and collisions should be
        //       rare, so use the more-compatible alternative.
        if (fun.call(thisArg, val, i, t)) {
          res.push(val);
        }
      }
    }

    return res;
  };
}

//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';
    if (typeof start !== 'number') {
      start = 0;
    }
    
    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}


//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/Reduce
if (!Array.prototype.reduce) {
  Array.prototype.reduce = function(callback /*, initialValue*/) {
    'use strict';
    if (this == null) {
      throw new TypeError('Array.prototype.reduce called on null or undefined');
    }
    if (typeof callback !== 'function') {
      throw new TypeError(callback + ' is not a function');
    }
    let t = Object(this), len = t.length >>> 0, k = 0, value;
    // tslint:disable-next-line:triple-equals
    if (arguments.length == 2) { // eslint-disable-line eqeqeq
      value = arguments[1];
    } else {
      while (k < len && !(k in t)) {
        k++; 
      }
      if (k >= len) {
        throw new TypeError('Reduce of empty array with no initial value');
      }
      value = t[k++];
    }
    for (; k < len; k++) {
      if (k in t) {
        value = callback(value, t[k], k, t);
      }
    }
    return value;
  };
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map
// Production steps of ECMA-262, Edition 5, 15.4.4.19
// Reference: http://es5.github.io/#x15.4.4.19
if (!Array.prototype.map) {

  Array.prototype.map = function(callback, thisArg) {

    let T, A, k;

    if (this == null) {
      throw new TypeError(' this is null or not defined');
    }

    // 1. Let O be the result of calling ToObject passing the |this| 
    //    value as the argument.
    let O = Object(this);

    // 2. Let lenValue be the result of calling the Get internal 
    //    method of O with the argument "length".
    // 3. Let len be ToUint32(lenValue).
    let len = O.length >>> 0;

    // 4. If IsCallable(callback) is false, throw a TypeError exception.
    // See: http://es5.github.com/#x9.11
    if (typeof callback !== 'function') {
      throw new TypeError(callback + ' is not a function');
    }

    // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
    if (arguments.length > 1) {
      T = thisArg;
    }

    // 6. Let A be a new array created as if by the expression new Array(len) 
    //    where Array is the standard built-in constructor with that name and 
    //    len is the value of len.
    A = new Array(len);

    // 7. Let k be 0
    k = 0;

    // 8. Repeat, while k < len
    while (k < len) {

      let kValue, mappedValue;

      // a. Let Pk be ToString(k).
      //   This is implicit for LHS operands of the in operator
      // b. Let kPresent be the result of calling the HasProperty internal 
      //    method of O with argument Pk.
      //   This step can be combined with c
      // c. If kPresent is true, then
      if (k in O) {

        // i. Let kValue be the result of calling the Get internal 
        //    method of O with argument Pk.
        kValue = O[k];

        // ii. Let mappedValue be the result of calling the Call internal 
        //     method of callback with T as the this value and argument 
        //     list containing kValue, k, and O.
        mappedValue = callback.call(T, kValue, k, O);

        // iii. Call the DefineOwnProperty internal method of A with arguments
        // Pk, Property Descriptor
        // { Value: mappedValue,
        //   Writable: true,
        //   Enumerable: true,
        //   Configurable: true },
        // and false.

        // In browsers that support Object.defineProperty, use the following:
        // Object.defineProperty(A, k, {
        //   value: mappedValue,
        //   writable: true,
        //   enumerable: true,
        //   configurable: true
        // });

        // For best browser support, use the following:
        A[k] = mappedValue;
      }
      // d. Increase k by 1.
      k++;
    }

    // 9. return A
    return A;
  };
}

// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
if (!Object.keys) {
  Object.keys = (function() {
    'use strict';
    let hasOwnProperty = Object.prototype.hasOwnProperty,
        hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
        dontEnums = [
          'toString',
          'toLocaleString',
          'valueOf',
          'hasOwnProperty',
          'isPrototypeOf',
          'propertyIsEnumerable',
          'constructor'
        ],
        dontEnumsLength = dontEnums.length;

    return function(obj) {
      if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
        throw new TypeError('Object.keys called on non-object');
      }

      let result = [], prop, i;

      for (prop in obj) {
        if (hasOwnProperty.call(obj, prop)) {
          result.push(prop);
        }
      }

      if (hasDontEnumBug) {
        for (i = 0; i < dontEnumsLength; i++) {
          if (hasOwnProperty.call(obj, dontEnums[i])) {
            result.push(dontEnums[i]);
          }
        }
      }
      return result;
    };
  }());
}


 /**** HELPER FUNCTIONS *****/

 if (typeof jQuery !== 'undefined' && typeof jQuery.fn !== 'undefined') {
     (jQuery.fn as any).sort = function() {  // tslint:disable-line
         return this.pushStack( [].sort.apply( this, arguments ), []);  
     };
 }



/*
http://stackoverflow.com/questions/1988349/array-push-if-does-not-exist
USAGE:
var array = [{ name: "tom", text: "tasty" }];
var element = { name: "tom", text: "tasty" };
array.pushIfNotExist(element, function(e) { 
    return e.name === element.name && e.text === element.text; 
});
 */



// check if an element exists in array using a comparer function
// comparer : function(currentElement)
Array.prototype.inArray = function(comparer) { 
    for(let i = 0; i < this.length; i++) { 
        if(comparer(this[i])) { return true; } 
    }
    return false; 
}; 

// adds an element to the array if it does not already exist using a comparer 
// function
Array.prototype.pushIfNotExist = function(element, comparer?): any[] { 
    if (typeof comparer === "undefined") {
        comparer = (e) => e === element;
    }
    if (!this.inArray(comparer)) {
        this.push(element);
    }
    return this; // TODO: verify this (added in oct 2018)
}; 




export class Utils {
 
    public static waitForFinalEvent = (function () {
        /* http://stackoverflow.com/questions/2854407/javascript-jquery-window-resize-how-to-fire-after-the-resize-is-completed
        * USAGE: 
        * $(window).resize(function () {
                Utils.waitForFinalEvent(function(){
                alert('Resize...');
                //...
                }, 500, "some unique string");
            });
        * 
        */
        
        let timers = {};
        return function (callback, ms, uniqueId) {
            if (!uniqueId) {
            uniqueId = "Don't call this twice without a uniqueId";
            }
            if (timers[uniqueId]) {
            clearTimeout(timers[uniqueId]);
            }
            timers[uniqueId] = setTimeout(callback, ms);
        };
    })();
 
    public static getBaseURL = () => {
        //log("get base url");
        //http://www.gotknowhow.com/articles/how-to-get-the-base-url-with-javascript
        let url = location.href;  // entire url including querystring - also: window.location.href;
        let baseURL = url.substring(0, url.indexOf('/', 14));

        return baseURL + "/";
        
        // if (baseURL.indexOf('//localhost') !== -1) {
        //     // Base Url for localhost
        //     url = location.href;  // window.location.href;
        //     var pathname = location.pathname;  // window.location.pathname;
        //     var index1 = url.indexOf(pathname);
        //     var index2 = url.indexOf("/", index1 + 1);
        //     var baseLocalUrl = url.substr(0, index2);

        //     // return baseLocalUrl + "/";
        //     return url;// updated to gulp serve
        // }
        // else {
        //     // Root Url for domain name
        //     return baseURL + "/";
        // }

    }
 
    public static isLocalhost = () => {
        let url = location.href;  // entire url including querystring - also: window.location.href;
        let baseURL = url.substring(0, url.indexOf('/', 14));
        if (baseURL.indexOf('//localhost') !== -1) {
            return true;
        }
        return false;
    }
    
    
    public static isEmpty = (data) => { // based on James Edwards' empty()
        /* tslint:disable:triple-equals */
        if (typeof (data) == 'number' || typeof (data) == 'boolean') {
            return false;
        }
        if (typeof (data) == 'undefined' || data === null) {
            return true;
        }
        if (typeof (data.length) !== 'undefined') {
            return data.length == 0; // eslint-disable-line eqeqeq
        }
        let count = 0;
        for (let i in data) {
            if (data.hasOwnProperty(i)) {
                count++;
            }
        }
        return count == 0;// eslint-disable-line eqeqeq
        /* tslint:enable:triple-equals */
    }

    public static strDashedToCaps = (str) => {
        return str.split('-').map(function capitalize(part) {
            return part.charAt(0).toUpperCase() + part.slice(1);
        }).join(' ');
    }
    
    
    public static splitStringToArray = (str, sep) => {
        let temp = [];
        return str.split(sep);
    }

    public static escapeHtml = (str) => {
        //http://stackoverflow.com/questions/24816/escaping-html-strings-with-jquery
        // based on https://github.com/janl/mustache.js/blob/master/mustache.js#L82
        let entityMap = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': '&quot;',
            "'": '&#39;',
            "/": '&#x2F;'
        };
        return String(str).replace(/[&<>"'\/]/g, function (s) {
            return entityMap[s];
        });
    }

    
    public static removeSpecialChars = (str) => {
        return String(str)
                //.replace(/[^a-zA-Z0-9]/g,'-');
                .replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
    }
    public static changeSpacesToDashes = (str) => {
        return String(str).replace(/\s+/g, '-');
    }
    
    public static objectHasProperty = (myObj, myProp) => {
        return myObj.hasOwnProperty(myProp);
    }
    
    public static isEmptyObject = (obj) => {
        for(let prop in obj) {
            if(obj.hasOwnProperty(prop)) {
                return false;
            }
        }
        return true;
    }
    
    public static checkIfElementEmptyElseDefault = (objContainer, elName, defaultVal) => {
        let sRtn = "";
        if (!Utils.isEmptyObject(objContainer[elName])) {
            sRtn = objContainer[elName];
        } else {
            sRtn = defaultVal;
        }
        return sRtn;
    }
    
    public static getObjects = (obj, key, val) => {
        let self = Utils;
        let objects = [];
        for (let i in obj) {
            if (!obj.hasOwnProperty(i)) { continue; }
            if (typeof obj[i] === 'object') {
                objects = objects.concat(self.getObjects(obj[i], key, val));
            } else if (i === key && obj[key] === val) {
                objects.push(obj);
            }
        }
        return objects;
    }
    
    public static strDecodeURI = (str) => {
        let sRet = str;
        try {
            sRet = decodeURIComponent(str);
        } catch (err) {
            // console.log('strDecodeURI caught ');//,err);
            //log(str);
            sRet = str;
        }
        return sRet;
    }
    
    public static strEncodeURI = (str) => {
        if (Utils.strDecodeURI(str) !== str) {
            return str;
        } else {
            return encodeURIComponent(str);
        }
    }

    public static tryParseInt = (str,defaultValue) => {
        if (typeof str === "number" && str % 1 === 0) {
            return str;//already an int
        }
        let retValue = defaultValue;
        if(typeof str !== "undefined" && str !== null) {
            if(str.length > 0) {
                if (!isNaN(str)) {
                    retValue = parseInt(str, 10);
                }
            }
        }
        return retValue;
    }
    
    public static roundDec = (value: number, decimals: number) => { 
        // a better solution than toFixed(decimals) 
        // ref: http://www.jacklmoore.com/notes/rounding-in-javascript/ 
        // return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals); // complicated with Typescript, not used anymore anyways
        return value.toFixed(decimals);
    }
    
    public static getPathToFolder = (folderName) => {
        //var baseFolder =  window.location.pathname.replace('/','').split('/')[0];
        let pathArray = window.location.pathname.replace('/','').split('/');
        //log(pathArray);    
        let url = "";//window.location.protocol + "//" + window.location.host + "/";// + window.location.pathname;
        for (let i = 0,len = pathArray.length; i < len; i++) {
            url += pathArray[i] + "/";
            if (pathArray[i] === folderName) {
                break;                    
            }
        }
        return url;
    }

    public static path = (url) => {
        return /(.*\/)[^\/]*$/gi.exec(url)[1];
    }
    
    // not used
    // static getWidthOfContents = ($el) => {
    //     //log('getWidthOfContents > el = %o' , $el);
    //     var totalWidth = 0;
    //     var notsurewhyweneedthisoffset = 4;// maybe border widths? couldnt find padding in inspector changed to each
        
    //     $el.children().each(function(index) {
    //         //log($(this).outerWidth(true));
    //         totalWidth += Math.ceil(parseInt($(this).outerWidth(true), 10));
    //         totalWidth += notsurewhyweneedthisoffset;
    //     });

    //     //totalWidth += notsurewhyweneedthisoffset;

    //     //log('getWidthOfContents () > Total Width = ' + totalWidth + ' (added offset = '+notsurewhyweneedthisoffset+')');
    //     log('getWidthOfContents() = %i for el : %o' ,totalWidth, $el);

    //     return (totalWidth);
    // };

    public static paramsToString = (data) => {
        return $.param( data );
    }
 
    public static sortBy = (field, reverse, primer) => {
        let key = function (x) { return primer ? primer(x[field]) : x[field]; };
        
        return function (a,b) {
            let A = key(a), B = key(b);
            return ( (A < B) ? -1 : ((A > B) ? 1 : 0) ) * [-1,1][+!!reverse];                  
        };
    }
    
    public static groupBy = (xs, key) => {
        return xs.reduce(function(rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    }

    public static removeByAttr = (arr, attr, value) => {
        let i = arr.length;
        while(i--) {
        if( arr[i] 
            && arr[i].hasOwnProperty(attr) 
            && (arguments.length > 2 && arr[i][attr] === value ) ) { 
    
            arr.splice(i,1);
    
        }
        }
        return arr;
    }
    
    public static updateByAttr = (arr, attr, value, newvalue) => {
        let i = arr.length;
        while(i--) {
        if( arr[i] 
            && arr[i].hasOwnProperty(attr) 
            && (arguments.length > 2 && arr[i][attr] === value ) ) { 
    
            arr[i][attr] = newvalue;
    
        }
        }
        return arr;
    }
    
    public static checkIfVarIsNotNullObj = (v) => {
        return (v !== null && typeof v === 'object' ? true : false);
    }
    public static checkIfNotNullAndLength = (v) => {
        if (Utils.checkIfVarIsNotNullObj(v)) {
            return (v.length > 0);
        } else {
            return false;
        }
    }
            
    
    public static idInArray = (array, id) => {
        for(let i = 0; i < array.length; i++) {
            if(array[i][0].id === id) {
                return true;
            }
        }
        return false;
    }
    public static valInArray = (array, val) => {
        return (jQuery.inArray(val, array) > -1);
    }
    
    public static getRandomNum = (min, max) => {
        return Math.floor(Math.random() * (max - min + 1) + min);

    }
    
    public static getRandomSubarray = (arr, size) => { //http://stackoverflow.com/questions/11935175/sampling-a-random-subset-from-an-array/11935263
        let shuffled = arr.slice(0), i = arr.length, temp, index;
        while (i--) {
            index = Math.floor((i + 1) * Math.random());
            temp = shuffled[index];
            shuffled[index] = shuffled[i];
            shuffled[i] = temp;
        }
        return shuffled.slice(0, size);
    }
    
    /**
     * Shuffles array in place.
     * @param {Array} a items The array containing the items.
     * ref: http://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array-in-javascript
     */
    public static shuffle = (a) => {
        let j, x, i;
        for (i = a.length; i; i -= 1) {
            j = Math.floor(Math.random() * i);
            x = a[i - 1];
            a[i - 1] = a[j];
            a[j] = x;
        }
    }

    
    // pushIfNotInArray = (array, val) {
    //     if (!array || !_.isArray(array) ) {
    //         warn("what's this nonArray doing here?",array);
    //     }
    //     if (array && _.isArray(array) && !this.valInArray(array, val)) {
    //         array.push(val);
    //     }
    // };
    
    public static decodeHtmlNumeric = ( str ) => {
        return str.replace( /&#([0-9]{1,7});/g, function( g, m1 ) {
            return String.fromCharCode( parseInt( m1, 10 ) );
        }).replace( /&#[xX]([0-9a-fA-F]{1,6});/g, function( g, m1 ) {
            return String.fromCharCode( parseInt( m1, 16 ) );
        });
    }
    
    public static getFirstXchars = (str, x) => {
        let sRet = "";
        if (str) {
            if (str.length > 0) {
                str = Utils.decodeHtmlNumeric(str);
                if (str.length > x) {
                    str = str.slice(0,x);
                }
            }
            sRet = str;
        }
        
        return sRet;
    }
    
    public static getFirstCharUpper = (str) => {
        if (str && typeof str === "string" && str.length > 0) {
            return str.substring(0, 1).toUpperCase();
        }
        return "";
    }
    
    public static getURLParameter = (sParamName) => {
        let sPageURL = window.location.search.substring(1);
        let sURLVars = sPageURL.split('&');
        for (let i = 0; i < sURLVars.length; i++) {
            let sParam = sURLVars[i].split('=');
            if (sParam[0] === sParamName) {
                return sParam[1];
            }
        }
    }

    public static getURLParamsObj = () => {
        let sPageURL = window.location.search;
        if (sPageURL && sPageURL.length > 1) {
            sPageURL = sPageURL.substring(1);
            return Utils.getParamsObj(sPageURL);
        }
        return {};
    }

    public static getParamsObj = (qs) => {
        let oRet = {},
            aURLVars = qs.split('&');
        for (let i = 0; i < aURLVars.length; i++) {
            let aParam = aURLVars[i].split('=');
            if (aParam && aParam.length > 1) {
                oRet[aParam[0]] = aParam[1];
            }
        }
        return oRet;
    }

    public static toQueryString = (obj) => {
        let parts = [];
        for (let i in obj) {
            if (obj.hasOwnProperty(i)) {
                parts.push(encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]));
            }
        }
        return parts.join("&");
    }

    
    //supposedly the split is faster than regex - http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
    public static getParameterByName = (name) => {
        // usage: var prodId = getParameterByName('prodId');
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        let regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }
    
    
    public static getTypeFromModel = (model) => {
        //log('getTypeFromModel: ',model);
        if (!Utils.isEmpty(model.cat_type)) {
            return model.cat_type;
        } else if(!Utils.isEmpty(model.icons) && !Utils.isEmpty(model.icons.taxa) && !Utils.isEmpty(model.icons.taxa.type)) {
            if (model.icons.taxa.type.length > 0 && !Utils.isEmpty(model.icons.taxa.type[0].name)) {
                return model.icons.taxa.type[0].name;
            }
        }
        return "na";
    }
    
    public static strEndsWithSlash = (str) => {
        if (typeof str === "string" && str.length > 1 && typeof str.substr === "function") {
            return str + (str.substr(-1) !== '/' ? '/' : '');
        }
        return str.toString();
    }

    public static strTruncate = (str, n, sep) => {
        sep = sep || '...';
        let sepLen = sep.length;
        //sep = '&hellip;'
        return (str.length > n) ? str.substr(0, n - sepLen) + sep : str;
    }

    // String.prototype.toHHMMSS = function () {
//   //usage:  "seconds".toHHMMSS()

//     var secNum = parseInt(this, 10); // don't forget the second param
//     var hours   = Math.floor(secNum / 3600);
//     var minutes = Math.floor((secNum - (hours * 3600)) / 60);
//     var seconds = secNum - (hours * 3600) - (minutes * 60);

//     if (hours   < 10) {hours   = "0"+hours;}
//     if (minutes < 10) {minutes = "0"+minutes;}
//     if (seconds < 10) {seconds = "0"+seconds;}
//     var time    = hours+':'+minutes+':'+seconds;
//     return time;
// };

    public static toHHMMSS = (o) => { /*eslint-disable no-multi-spaces */
        let t = o.toString();
        let secNum = parseInt(t, 10); // don't forget the second param
        let hours: number | string   = Math.floor(secNum / 3600);
        let minutes: number | string = Math.floor((secNum - (hours * 3600)) / 60);
        let seconds: number | string = secNum - (hours * 3600) - (minutes * 60);
        
        if (hours   < 10) { hours   = "0" + hours; }
        if (minutes < 10) { minutes = "0" + minutes; }
        if (seconds < 10) { seconds = "0" + seconds; }
        let time    = hours + ':' + minutes + ':' + seconds;
        return time;/*eslint-enable no-multi-spaces */
    }

    public static hmsToSeconds = (str) => {
        let s = 0;
        if (str && typeof str.split === 'function') {
            let p = str.split(':'),
                m = 1;
        
            while (p.length > 0) {
                s += m * parseInt(p.pop(), 10);
                m *= 60;
            }
        } else {
            console.warn("hmsToSeconds str.split error",str);
        }
    
        return s;
    }
    
    public static prettyPrintData = (data) => { //http://www.benknowscode.com/2013/03/leveraging-jquery-ui-sortable-widget-in_3676.html
         return JSON.stringify(data.toJSON()).replace(/{/g, '\n\t{').slice(0, -1) + '\n]';
    }
    
    public static isJsonString = (str) => {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }
    public static tryParseJsonStr = (str) => {
        try {
            let j = JSON.parse(str);
            return j;
        } catch (e) {
            return str;
        }
    }
    
    public static generateUUID = () => {
        let d = new Date().getTime();
        let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            
            let r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            /* tslint:disable:triple-equals space-infix-ops */
            let bitwise = (c == 'x' ? r : (r&0x3|0x8)).toString(16);// eslint-disable-line eqeqeq
            /* tslint:enable:triple-equals space-infix-ops */
            return bitwise;
        });
        return uuid;
    }
    
    
    public static getTimeStampString = (dte) => {//https://gist.github.com/hurjas/2660489
        //Return a timestamp with the format "m/d/yy h:MM:ss TT"
        let now;// = new Date();
        // Create a date object with the current time
        if (Utils.isEmpty(dte)) {
            now = new Date();
        } else {
            now = new Date(dte);
        }
        // Create an array with the current month, day and time
        let date = [ now.getMonth() + 1, now.getDate(), now.getFullYear() ];
        // Create an array with the current hour, minute and second
        let time = [ now.getHours(), now.getMinutes(), now.getSeconds() ];
        // Determine AM or PM suffix based on the hour
        let suffix = ( time[0] < 12 ) ? "AM" : "PM";
        // Convert hour from military time
        time[0] = ( time[0] < 12 ) ? time[0] : time[0] - 12;
        // If hour is 0, set it to 12
        time[0] = time[0] || 12;
        // If seconds and minutes are less than 10, add a zero
        for ( let i = 1; i < 3; i++ ) {
            if ( time[i] < 10 ) {
            time[i] = "0" + time[i];
            }
        }
        // Return the formatted string
        return date.join("/") + " " + time.join(":") + " " + suffix;

    }
    
    public static getDateStamp = () => {
        // Create a filename datestamp 
        let now = new Date(); 
        //make it 2 digits for mo and day
        let month = now.getMonth() + 1;//getMonth returns a number between 0 and 11, not 1 and 12
        let twoDigitMonth = ((month) >= 10) ? (month) : '0' + (month);  
        let day = now.getDate();
        let twoDigitDate = ((day) >= 10) ? (day) : '0' + (day);
        //var createdDateTo = currentDate.getFullYear() + "-" + twoDigitMonth + "-" + twoDigitDate; 
        // Create an array with the current month, day and time
        let date = [ now.getFullYear(), twoDigitMonth, twoDigitDate ];//now.getMonth() + 1, now.getDate() ];
        // Return the formatted string
        return date.join("");
    }
    

    public static getTimeStamp = () => {
        return Math.floor(Date.now() / 1000); // same as in the Aws Lambda function
    }
    
    
    public static getElementByClassNameElseCreate = (className, elementType) => {
        if (typeof elementType === "undefined") { elementType = "div"; }
        if ($("." + className).length) {
            return $("." + className);
        } else {
            return $(document.createElement(elementType)).addClass(className);
        }
    }

    public static findChildElementByClassNameElseCreate = ($parent, className, elementType) => {
        if (typeof elementType === "undefined") { elementType = "div"; }
        //log($parent.find("."+className));
        if ($parent.find("." + className).length > 0) {
            return $parent.find("." + className).first();
        } else {
            
            return $(document.createElement(elementType)).addClass(className).appendTo($parent);
        }
    }
    
    public static smoothScrollTo = (loc, callback?, scrollTo?, doLog = false) => {
        
        let topnavHeight = 92,
            sel = "body",
            completeCalled = false;
        scrollTo = scrollTo || 0;
        
        switch (loc) {
            case "top":
                scrollTo = 0;
                break;
            
            case "nav":
                scrollTo = topnavHeight;
                break;
            
            case "offsetNav":
                scrollTo = scrollTo - topnavHeight;
                break;
            
            default:
                if (scrollTo === 0) {
                    // log("smoothScrollTo > no handler, doing nothing..",loc);
                    if (typeof callback === "function") {
                        callback(false);
                    }
                    return;
                } 
        }
        if(doLog) {
            console.log("smoothScrollTo :",scrollTo);
        }
        
        $("html, body").animate({ scrollTop: scrollTo }, 400, function() {
            //done
            if(!completeCalled) {
                // since we are using html & body it gets called 2x
                completeCalled = true;
                if (typeof callback === "function") {
                    callback(this);
                }
            }
        });
    }
    
} //end utils



// HELPER functions - used?
    
    
    // function idInDict (array, id) {
    //     for(var i=0;i<array.length;i++) {
    //         if(array[i].id === id) {
    //             return true;
    //         }
    //     }
    //     return false;
    // }
    
    // function addCountToClipArray (arr, nid, oClip) {
    //     if (!idInDict(arr,nid)) {
    //         if (typeof oClip !== "undefined") {
    //             arr.push({
    //                 id: nid, 
    //                 count: 1, 
    //                 nid: oClip.nid,
    //                 "node-title": oClip["node-title"],
    //                 "clip_length": oClip["clip_length"],
    //                 poster: oClip.poster,
    //                 recommended: oClip.recommended,
    //                 suggested: oClip.suggested,
    //                 title: oClip.title,
    //                 youtube_id: oClip.youtube_id,
    //                 icons: oClip.icons
    //             });
    //         } else {
    //             arr.push({id: nid, count: 1});
    //         }
    //     } else {
    //         for(var i=0;i<arr.length;i++) {
    //             if(arr[i].id === nid) {
    //                 arr[i].count = arr[i].count + 1;
    //             }
    //         }
    //     }
    // }
    
    // function addCountToArray (arr, nid) {
    //     if (!idInDict(arr,nid)) {
    //         arr.push({id: nid, count: 1});
    //     } else {
    //         for(var i=0;i<arr.length;i++) {
    //             if(arr[i].id === nid) {
    //                 arr[i].count = arr[i].count + 1;
    //             }
    //         }
    //     }
    // }
